<template>
	<div class="single-file-uploader">
		<!-- 上传按钮 -->
		<el-upload class="upload-btn" :action="uploadUrl" :headers="headers" :file-list="currentFileList"
			:accept="acceptTypes" :on-success="handleSuccess" :on-error="handleError" :before-upload="beforeUpload"
			:on-remove="handleRemove" :disabled="isDisabled" :auto-upload="true" :http-request="customUpload"
			list-type="text" :show-file-list="false" v-if="!del">
			<el-button size="small" type="primary" :disabled="isDisabled">
				<i class="el-icon-upload"></i> 选择文件上传
			</el-button>
		</el-upload>

		<!-- 上传进度条 -->
		<el-progress v-if="isUploading" :percentage="uploadPercentage" :stroke-width="2"
			style="margin: 10px 0;"></el-progress>

		<!-- 已上传文件列表（同时显示父组件传递的 + 子组件新增的） -->
		<div class="file-list" v-if="uploadedFiles.length > 0">
			<div class="list-title">已上传文件（{{ uploadedFiles.length }}/20）</div>
			<el-table :data="uploadedFiles" border size="mini" :show-header="false"
				style="width: 100%; margin-top: 10px">
				<el-table-column prop="name" width="calc(100% - 160px)">
					<template slot-scope="scope">
						<a :href="scope.row.url" target="_blank" v-if="scope.row.url" class="file-link">
							{{ scope.row.name }}
						</a>
						<span v-else>{{ scope.row.name }}</span>
					</template>
				</el-table-column>
				<el-table-column width="80">
					<template slot-scope="scope">
						<el-button icon="el-icon-view" size="mini" type="text" @click="handlePreview(scope.row)"
							:disabled="!scope.row.url"></el-button>
					</template>
				</el-table-column>
				<el-table-column width="80" v-if="!del">
					<template slot-scope="scope">
						<el-button icon="el-icon-delete" size="mini" type="text"
							@click="handleDelete(scope.row)"></el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>

		<!-- 上传提示 -->
		<div class="upload-tips">
			支持格式：{{ acceptTypesText }} | 单个文件不超过{{ fileSizeLimit }}MB | 最多上传20个文件
		</div>

		<!-- 预览区域：绝对定位 + 固定宽高 -->
		<div class="preview-mask" v-if="previewVisible" @click="previewVisible = false"></div>
		<div class="preview-container" v-if="previewVisible">
			<div class="preview-close" @click="previewVisible = false">
				<i class="el-icon-close"></i>
			</div>
			<div class="preview-content">
				<img v-if="previewUrl && isImageFile(previewUrl)" :src="previewUrl" class="preview-image" alt="图片预览">
				<div v-else-if="previewUrl" class="non-image-preview">
					<p>文件类型不支持预览</p>
					<p class="preview-link">
						<a :href="previewUrl" target="_blank" class="external-link">
							<i class="el-icon-external"></i> 点击打开文件
						</a>
					</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import axios from 'axios';
	import {
		Setitem,
		Getitem
	} from "../../utils/item.js";

	export default {
		name: 'SingleFileUploader',
		props: {
			del: {
				type: String,
				default: ''
			},
			acceptTypes: {
				type: String,
				default: '.jpg,.jpeg,.png,.doc,.docx,.xls,.xlsx,.pdf,.txt,.dwg,.dxf'
			},
			// 提示文本增加CAD说明
			acceptTypesText: {
				type: String,
				default: '图片、文档、PDF、TXT、CAD(.dwg,.dxf)'
			},
			fileSizeLimit: {
				type: Number,
				default: 100
			},
			initialFiles: {
				type: Array,
				required: true,
				validator: (val) => {
					if (!Array.isArray(val)) return false;
					return val.every(file => {
						return file.name && file.url; // 只校验name和url
					});
				}
			}
		},
		created() {
			this.uploadedFiles = this.initialFiles
		},
		data() {
			return {
				uploadUrl: 'https://nmwtzx.com/wtzx/project/type/upload',
				currentFileList: [],
				uploadedFiles: [], // 最终显示的总列表（只包含name和url）
				isUploading: false,
				uploadPercentage: 0,
				previewVisible: false,
				previewUrl: '',
				token: Getitem('user') ? (typeof Getitem('user') === 'object' ? Getitem('user').token : Getitem('user')) :
					''
			}
		},
		computed: {
			headers() {
				return {
					"ClientId": "pc_manage",
					"token": this.token
				}
			},
			isDisabled() {
				return this.uploadedFiles.length >= 20 || this.isUploading;
			}
		},
		watch: {
			// 监听父组件传递的 initialFiles 变化
			initialFiles: {
				immediate: true,
				deep: true,
				handler(newVal) {
					// 父组件传递的列表可能超过10个，截取前10个
					const validList = newVal.slice(0, 10);
					// 提取并保留需要的字段（仅name和url），过滤掉其他字段
					const filteredList = validList.map(file => ({
						name: file.name,
						url: file.url
					}));
					// 去重处理（基于name和url的组合）
					this.uploadedFiles = filteredList.filter((file, index, self) => {
						return self.findIndex(f => f.name === file.name && f.url === file.url) === index;
					});
					// 同步通知父组件（仅包含name和url）
					this.$emit('fileChange', [...this.uploadedFiles]);
				}
			}
		},
		methods: {

			customUpload(params) {
				this.$emit('uping')
				const {
					file
				} = params;
				const formData = new FormData();
				formData.append('file', file);

				axios.post(this.uploadUrl, formData, {
					headers: this.headers,
					onUploadProgress: (progressEvent) => {
						if (progressEvent.total) {
							this.uploadPercentage = Math.round((progressEvent.loaded / progressEvent.total) *
								100);
						}
					}
				}).then(response => {
					params.onSuccess(response.data);
				}).catch(error => {
					// console.error('上传接口错误：', error.response?.data || error.message);
					params.onError(error);
				});
			},

			beforeUpload(file) {
				// 校验总文件数
				if (this.uploadedFiles.length >= 20) {
					this.$message.warning('最多只能上传20个文件，无法继续添加');
					return false;
				}

				// 校验文件大小
				const maxSize = this.fileSizeLimit * 1024 * 1024;
				if (file.size > maxSize) {
					this.$message.error(`单个文件大小不能超过${this.fileSizeLimit}MB`);
					return false;
				}

				// 校验token
				if (!this.token) {
					this.$message.error('登录状态失效，请重新登录');
					return false;
				}

				this.isUploading = true;
				this.uploadPercentage = 0;
				return true;
			},

			handleSuccess(response, file, fileList) {
				this.isUploading = false;
				if (response.code === 200) {
					// 子组件新增的文件格式（只保留name和url，移除id、size、type）
					const newFile = {
						name: file.name, // 只保留文件名
						url: response.data // 只保留文件地址
					};

					// 新增后总列表不超过10个
					if (this.uploadedFiles.length < 20) {
						// 检查是否已存在相同文件（基于name和url）
						const isDuplicate = this.uploadedFiles.some(f => f.name === newFile.name);
						if (!isDuplicate) {
							this.uploadedFiles.push(newFile);
							this.$message.success(`${file.name} 上传成功`);
							// 通知父组件：总列表更新（只包含name和url）
							this.$emit('fileChange', [...this.uploadedFiles]);
						} else {
							this.$message.warning('该文件已存在');
						}
					} else {
						this.$message.warning('文件上传成功，但已达20个文件上限，无法显示');
					}
				} else {
					this.$message.error(`${file.name} 上传失败：${response.msg || '未知错误'}`);
				}
			},

			handleError(err, file) {
				this.isUploading = false;
				this.$message.error(`${file.name} 上传失败，请重试`);
			},

			handleDelete(file) {
				this.$confirm(`确定要删除文件 "${file.name}" 吗？`)
					.then(() => {
						// 基于name和url删除（因为没有id了）
						this.uploadedFiles = this.uploadedFiles.filter(item =>
							!(item.name === file.name && item.url === file.url)
						);
						this.$message.success('文件已删除');
						// 通知父组件删除后的最新列表
						this.$emit('fileChange', [...this.uploadedFiles]);
					})
					.catch(() => {});
			},

			handlePreview(file) {
				this.previewUrl = file.url;
				this.previewVisible = true;
				document.body.style.overflow = 'hidden';
			},

			isImageFile(url) {
				const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'];
				const ext = url.split('.').pop().toLowerCase();
				return imageExtensions.includes(ext);
			},

			handleRemove(file, fileList) {
				this.currentFileList = fileList;
			}
		},
		watch: {
			previewVisible(newVal) {
				document.body.style.overflow = newVal ? 'hidden' : 'auto';
			}
		}
	}
</script>

<style scoped>
	.single-file-uploader {
		padding: 15px;
		border: 1px dashed #e6e6e6;
		border-radius: 4px;
		position: relative;
		z-index: 301;
	}

	.file-list {
		margin-top: 15px;
	}

	.list-title {
		font-size: 13px;
		color: #606266;
		font-weight: 500;
	}

	.upload-tips {
		margin-top: 10px;
		font-size: 12px;
		color: #909399;
	}

	::v-deep .upload-btn {
		margin-bottom: 5px;
	}

	.file-link {
		color: #409eff;
		text-decoration: none;
	}

	.file-link:hover {
		text-decoration: underline;
	}

	.preview-mask {
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background-color: rgba(0, 0, 0, 0.7);
		z-index: 200;
		cursor: pointer;
	}

	.preview-container {
		position: fixed;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		width: 60vw;
		height: 60vh;
		background-color: #fff;
		border-radius: 8px;
		z-index: 201;
		overflow: hidden;
		box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
	}

	.preview-close {
		position: absolute;
		top: 12px;
		right: 12px;
		font-size: 18px;
		color: #666;
		cursor: pointer;
		transition: color 0.2s;
		z-index: 202;
	}

	.preview-close:hover {
		color: #f56c6c;
	}

	.preview-content {
		width: 100%;
		height: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
		padding: 20px;
	}

	.preview-image {
		max-width: 100%;
		max-height: 100%;
		object-fit: contain;
	}

	.non-image-preview {
		text-align: center;
		color: #606266;
		font-size: 16px;
	}

	.preview-link {
		margin-top: 20px;
	}

	.external-link {
		color: #409eff;
		text-decoration: none;
		font-size: 14px;
		display: inline-flex;
		align-items: center;
		gap: 6px;
	}

	.external-link:hover {
		text-decoration: underline;
	}

	@media (max-width: 768px) {
		.preview-container {
			width: 90vw;
			height: 50vh;
		}
	}

	::v-deep .file-list .el-table {
		max-height: 300px;
		overflow-y: auto;
	}

	::v-deep .file-list .el-table__body-wrapper {
		overflow-x: hidden !important;
	}

	/* 调整表格行高，以便显示更多行 */
	::v-deep .file-list .el-table .el-table__row {
		height: 40px;
		/* 减少行高 */
	}

	/* 调整按钮大小 */
	::v-deep .file-list .el-button--mini {
		padding: 5px 8px;
	}
</style>